/**
 * Manage block-gallery-slider's sliders.
 */
(function ($) {
  /**
   * When switching views, freeze thumbnails if infinite scroll not active (not enough slides).
   */
  function thumbnailsHelper(thumbsSlick, largesSlick, thumbnailsIdxClass) {
    if (thumbsSlick.getOption("slidesToShow") > thumbsSlick.slideCount) {
      if (largesSlick) {
        largesSlick.setOption("asNavFor", "");
      }
      const asNavFor = thumbsSlick.getOption("asNavFor");
      thumbsSlick.setOption("asNavFor", "");
      thumbsSlick.slickGoTo(0);
      thumbsSlick.setOption("asNavFor", asNavFor);
    } else if (largesSlick) {
      largesSlick.setOption("asNavFor", `.${thumbnailsIdxClass}`);
    }
  }
  const speed = 300;
  const $body = $(document.body);
  const className = "wp-block-kehittamo-block-gallery-slider";
  // Close fullscreen modal on ESC
  $(document).keydown((e) => {
    if (e.key === "Escape") {
      const $fullscreen = $(`.${className}--fullscreen`);
      if ($fullscreen.length) {
        $body.removeClass("has-fullscreen-gallery");
        $fullscreen.removeClass(`${className}--fullscreen`);
        // Refresh sliders
        $fullscreen.find(`.${className}__larges`).slick("setPosition");
        const $thumbnails = $fullscreen.find(`.${className}__thumbnails`);
        thumbnailsHelper($thumbnails[0].slick);
        $thumbnails.slick("setPosition");
      }
    }
  });
  // Build all (block) gallery sliders.
  $(`.${className}`).each(function (i) {
    const $this = $(this);
    $this.addClass(`${className}--${i}`);
    const largesIdxClass = `${className}__larges--${i}`;
    const thumbnailsIdxClass = `${className}__thumbnails--${i}`;
    // Scrolling thumbnails (if more than slidesToShow)
    const $thumbnails = $this.find(`.${className}__thumbnails`);
    // Main large image
    const $larges = $this.find(`.${className}__larges`);
    $larges.addClass(largesIdxClass);
    const $largesIdxEl = $(`.${largesIdxClass}`);
    $largesIdxEl.slick({
      speed,
      arrows: false,
      asNavFor: `.${thumbnailsIdxClass}`,
      fade: true,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      swipe: false,
    });
    // Close fullscreen image on click.
    $this.find(`.${className}__larges`).click(() => {
      if ($this.hasClass(`${className}--fullscreen`)) {
        $body.toggleClass("has-fullscreen-gallery");
        $this.toggleClass(`${className}--fullscreen`);
        // Refresh sliders
        $larges.slick("setPosition");
        thumbnailsHelper($thumbnails[0].slick);
        $thumbnails.slick("setPosition");
      }
    });
    $this.find(`.${className}__fullscreen`).click(() => {
      $body.toggleClass("has-fullscreen-gallery");
      $this.toggleClass(`${className}--fullscreen`);
      // Refresh sliders
      $larges.slick("setPosition");
      thumbnailsHelper($thumbnails[0].slick);
      $thumbnails.slick("setPosition");
    });
    $thumbnails.addClass(thumbnailsIdxClass);
    const $thumbnailsIdxEl = $(`.${thumbnailsIdxClass}`);
    $thumbnailsIdxEl.slick({
      speed,
      arrows: false,
      asNavFor: `.${largesIdxClass}`,
      focusOnSelect: true,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 6,
      mobileFirst: true,
      swipe: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 10,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 14,
          },
        },
      ],
    });
    //
    // Freeze and unfreeze tumbnails correctly on window resize.
    $(window).on("resize", (e) => {
      $(`.${className}`).each((i) => {
        const largesIdxClass = `${className}__larges` + `--${i}`;
        const $largesIdxEl = $(`.${largesIdxClass}`);
        const largesSlick = $largesIdxEl[0].slick;
        const thumbnailsIdxClass = `${className}__thumbnails` + `--${i}`;
        const $thumbnailsIdxEl = $(`.${thumbnailsIdxClass}`);
        const thumbsSlick = $thumbnailsIdxEl[0].slick;

        thumbnailsHelper(thumbsSlick, largesSlick, thumbnailsIdxClass);
      });
    });
  });
})(jQuery); // Fully reference jQuery after this point.
